/**
 * Initializes Elkfox Ajaxinate for collection + search product grids.
 * Re-run after facet filter updates via window.initCollectionAjaxinate().
 */
(function () {
  var instance = null;
  var MIN_LOADING_MS = 2500;
  var LOADING_HTML =
    'Loading<span class="ajaxinate-loading-dots" aria-hidden="true"></span>';

  function injectAjaxinateStyles() {
    if (document.getElementById('ajaxinate-pagination-styles')) return;

    var style = document.createElement('style');
    style.id = 'ajaxinate-pagination-styles';
    style.textContent =
      '.ajaxinate-pagination a.is-loading { pointer-events: none; }' +
      '.ajaxinate-loading-dots::after {' +
      'content: ".";' +
      'display: inline-block;' +
      'width: 1.25em;' +
      'text-align: left;' +
      'animation: ajaxinate-dot-cycle 1.2s steps(1, end) infinite;' +
      '}' +
      '@keyframes ajaxinate-dot-cycle {' +
      '0% { content: "."; }' +
      '25% { content: ".."; }' +
      '50% { content: "..."; }' +
      '75% { content: "...."; }' +
      '100% { content: "."; }' +
      '}';
    document.head.appendChild(style);
  }

  function patchAjaxinateLoadMore() {
    if (!window.Ajaxinate || window.Ajaxinate.__minLoadingPatched) return;

    var originalLoadMore = window.Ajaxinate.prototype.loadMore;
    window.Ajaxinate.prototype.loadMore = function () {
      var self = this;
      var startedAt = Date.now();
      var loadingLink = this.paginationElement && this.paginationElement.querySelector('a');

      if (loadingLink) {
        loadingLink.classList.add('is-loading');
        loadingLink.innerHTML = this.settings.loadingText;
      }

      this.request = new XMLHttpRequest();
      this.request.onreadystatechange = function () {
        if (self.request.readyState !== 4 || self.request.status !== 200) return;

        var newContainer = self.request.responseXML.querySelectorAll(self.settings.container)[0];
        var newPagination = self.request.responseXML.querySelectorAll(self.settings.pagination)[0];
        var responseXML = self.request.responseXML;
        var remaining = Math.max(0, MIN_LOADING_MS - (Date.now() - startedAt));

        setTimeout(function () {
          if (newContainer) {
            self.containerElement.insertAdjacentHTML('beforeend', newContainer.innerHTML);
          }
          if (newPagination) {
            self.paginationElement.innerHTML = newPagination.innerHTML;
          }
          if (self.settings.callback && typeof self.settings.callback === 'function') {
            self.settings.callback(responseXML);
          }
          self.initialize();
        }, remaining);
      };

      this.request.open('GET', this.nextPageUrl);
      this.request.responseType = 'document';
      this.request.send();
    };

    window.Ajaxinate.prototype.loadMore.__original = originalLoadMore;
    window.Ajaxinate.__minLoadingPatched = true;
  }

  function initCollectionAjaxinate() {
    if (typeof window.Ajaxinate !== 'function') return;

    injectAjaxinateStyles();
    patchAjaxinateLoadMore();

    if (instance && typeof instance.destroy === 'function') {
      try {
        instance.destroy();
      } catch (e) {
        /* ignore */
      }
      instance = null;
    }

    var pagination = document.getElementById('AjaxinatePagination');
    var grid = document.getElementById('product-grid');
    if (!pagination || !grid || grid.tagName !== 'UL' || !pagination.querySelector('a')) return;

    instance = new Ajaxinate({
      container: '#product-grid',
      pagination: '#AjaxinatePagination',
      method: 'scroll',
      offset: 200,
      loadingText: LOADING_HTML,
      callback: function () {
        if (typeof window.wishlistButtonsInit === 'function') {
          window.wishlistButtonsInit();
        }
        document.querySelectorAll('#product-grid .scroll-trigger').forEach(function (el) {
          el.classList.add('scroll-trigger--cancel');
        });
      },
    });

    if (typeof instance.checkIfPaginationInView === 'function') {
      instance.checkIfPaginationInView();
    }
  }

  window.initCollectionAjaxinate = initCollectionAjaxinate;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionAjaxinate);
  } else {
    initCollectionAjaxinate();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector && event.target.querySelector('#AjaxinatePagination')) {
      initCollectionAjaxinate();
    }
  });
})();
